<template>
	<Pie :data="data" :options="options" />
</template>

<script>
import { Pie } from 'vue-chartjs'
import { useChart } from '@/composables/useChart'

const PieChart = {
	props: ['data', 'options'],
	components: { Pie },
	setup () {
		useChart()
	}
}

export default PieChart
export { PieChart as mdbPieChart }
</script>
